import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource ,PageEvent, MatDialog} from '@angular/material';
import { HttpService } from '../http.service';
import { Subscription } from 'rxjs';
import { Messages } from '../constants/messages';
import { EventService } from '../event.service';
import { StorageService } from '../storage.service';
import { Router } from '@angular/router';
import { TimeService } from '../time.service';
import { DeleteBillModalComponent } from './delete-bill-modal/delete-bill-modal.component';
import { SnackbarService } from '../snackbar.service';
import { DateTime } from 'luxon';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { CreditNoteComponent } from './credit-note/credit-note.component';


export interface Bill {
  id: string;
  bill_date: string;
  enterprise_name:string;
  unit_name:string;
  download_link:string;
  isDeleted:boolean;
}

@Component({
  selector: 'app-bills',
  templateUrl: './bills.component.html',
  styleUrls: ['./bills.component.scss']
})
export class BillsComponent implements OnInit {
  @ViewChild('commentDialog', {static: true}) commentDialog: TemplateRef<any>;
  @ViewChild("editConsolidateInvoice", { static: true }) editConsolidateInvoiceDialog: TemplateRef<any>; changeInvoiceType


  // displayColumns = ['bill_id', 'bill_date', 'enterprise_name', 'unit_name', 'download_link', 'action', 'qbo'];
  displayColumns = ['bill_no', 'shipper', 'received_on', 'payment_status', 'total_amount', 'received_amount','actions'];

  billsArray: any = [];
  totalBills = 0;
  bills: any = [];
  selectedStatus:any  = 'NON-SETTLED' ;//holds the selected status (Available/Deleted)
  transit_types = [
    {
      name:"Inter-State",
      value:"INTER"
    },
    {
      name:"Intra-State",
      value:"INTRA"
    },
  ]
  selectedTransitType:any ;
  status_data = {
    pending_for_payment:{ value:'',loader:false },
    completely_received:{ value:'',loader:false },
    partially_received:{ value:'',loader:false },
  }
  userId: any;
  url = '';
  commentDialogRef;
  showLoader = false;
  billsList: MatTableDataSource<Bill>;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  billFilters: any = {
      from:Date,
      to:Date,
      shipper:'',
      status:'NON-SETTLED',
      transit_type:'',
      limit:0,
      skip:0,
  };
  qboData: any = {
    user_id: '',
    lines: [],
    due_date: '',
    invoice_message: ''
  };

  shippersArray = [];
  selectedShipper:any;
  date_filter:any = {
    from_date: Date,
    to_date: Date,
    max:'',
    min:''
  }

  selectStatusArray = {
    non_settled:true,
    settled:false,
    par_settled:false,
  };
  currencySymbol;
  editConsolidateInvoiceRef: any;
  invoiceId: any;
  newInvoice: any;
  existingInvoice: any;


  carrierUpdates: Subscription;
  errors = new Messages();
  helpData = [
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
  ];
  constructor(private http: HttpService, private translation:TranslateService,private events: EventService, private storage: StorageService, private route: Router,
              private timeService: TimeService, private dialog: MatDialog, private snackBar: SnackbarService) {
    const access_token = this.storage.getFromCookie('access_token');
    if (!access_token) {
      this.route.navigateByUrl('login');
    }
  }

  ngOnInit() {
    // this.userId = JSON.parse(localStorage.getItem('userId'));
    // this.url = (environment.country === 'IN') ? environment.API_URL_QUICKBOOKS + 'authorize?user_id=' + this.userId : '';
    this.setTime();
    this.getShippers();
    const currency = JSON.parse(localStorage.getItem('carriers'));
    this.currencySymbol = currency[0].country.currency.symbol;
    this.carrierUpdates = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getShippers();
      }
    );
  }

  //set the time in the date picker
  setTime(){
    this.date_filter.from_date = ( d => new Date(d.setDate(d.getDate()-30)) )(new Date);//sets the from date to 30 days before date
    this.date_filter.from_date.setHours(0,0,0,0); //set hours to 12:00AM
    this.date_filter.to_date = new Date();//set the to_date to today's date
    this.date_filter.to_date.setHours(23,59,59,0); 
    this.billFilters.from = this.timeService.toUTCEpoch(this.date_filter.from_date);
    this.billFilters.to = this.timeService.toUTCEpoch(this.date_filter.to_date);
    this.date_filter.max = this.date_filter.to_date;
    this.date_filter.min = this.date_filter.from_date;
  }

  // get the shipper to populate the enterpise unit filter
  getShippers(){
    this.shippersArray = [
      {
        id: '',
        parent_name: 'All'
      }
    ];
    this.http.get('shippers').subscribe(
      (data:any)=>{
        if(data.statusCode == 200){
          data.data.forEach((element)=>{
            this.shippersArray.push({
              id:element._id,
              name:element.name,
              location:element.location,
              parent_name: element.parent_name
            })
          });
          this.selectShipper(this.shippersArray[0]);
        }
      }
    )
  }

  //select the shipper and get invoices based on the selected shipper
  selectShipper(shipper){
    this.selectedShipper = shipper;
    (shipper.id) ? this.billFilters.shipper = shipper.id : delete this.billFilters.shipper;
    this.selectTransitType(this.transit_types[0]);
    // this.getBills(this.billFilters);  
  }

  selectStatus(status,type){
    this.selectStatusArray = {
      non_settled:false,
      settled:false,
      par_settled:false,
    };
    this.selectStatusArray[type] = true;
    this.selectedStatus = status;
    this.billFilters.status = this.selectedStatus;
    this.getBills(this.billFilters);
  }

  //set the from_date when selected from the date picker 
  setFromDateTime(value) {
    this.date_filter.from_date = value.from_date;
    const t1 = DateTime.fromJSDate(value.from_date).toFormat('dd/MM/yyyy 00:00:00');
    const epoch: any = DateTime.fromFormat(t1, 'dd/MM/yyyy 00:00:00');//get the epoch time
    this.billFilters.from = epoch.ts;
    this.billFilters.to = this.timeService.toUTCEpoch(this.date_filter.to_date);
    this.getBills(this.billFilters);
    this.date_filter.min = this.date_filter.from_date;
  }
  
  //set to_date to the value set from the date picker
  setToDateTime(value) {
    this.date_filter.to_date = value.to_date;
    this.date_filter.to_date.setHours(23,59,59,0);
    const t1 = DateTime.fromJSDate(value.to_date).toFormat('dd/MM/yyyy hh:mm:ss a');
    const epoch: any = DateTime.fromFormat(t1, 'dd/MM/yyyy hh:mm:ss a');
    this.billFilters.to = epoch.ts;
    this.billFilters.from = this.timeService.toUTCEpoch(this.date_filter.from_date);
    this.getBills(this.billFilters);
    this.date_filter.max = this.date_filter.to_date;
  }
  
  ngOnDestroy() {
    this.carrierUpdates.unsubscribe();
  }

  getBills(filter: any = {}){
      filter.limit = this.paginator.pageSize || 25;
      filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);
      this.showLoader = true;
      this.status_data.pending_for_payment.loader = true;
      this.status_data.completely_received.loader = true;
      this.status_data.partially_received.loader = true;

      this.http.get('carrier_bill/get_all', filter,1).subscribe(
      (data: any) => {
        if ( data.statusCode == 200) {
          this.showLoader = false;
          //bill stats
          this.status_data.pending_for_payment.loader = false;
          this.status_data.completely_received.loader = false;
          this.status_data.partially_received.loader = false;
          this.status_data.pending_for_payment.value = data.data.stats.no_of_nonsettled ;
          this.status_data.completely_received.value = data.data.stats.no_of_settled ;
          this.status_data.partially_received.value = data.data.stats.no_of_par_settled;

          this.billsArray = data.data.bills ? data.data.bills : [];
          this.totalBills = data.data.count ? data.data.count : 0;
          this.bills = [];

          this.billsArray.forEach(element => {
            const temp: any = {};

            temp.id = element._id;
            temp.bill_id = element.CBIN.custom ? element.CBIN.custom : element.CBIN.default;
            temp.bill_date = this.timeService.toShortDateTime(element.created_at);
            temp.enterprise_name = element.shipper.parent_name;
            temp.unit_name = element.shipper.name;
            temp.pdf_link = element.pdf_link;
            temp.reason = element.delete_reason;
            temp.qbo = '';
            temp.amount = Math.trunc(element.final_amount) || '--';
            temp.currency = element.currency.symbol;
            temp.received_on = this.timeService.toShortDateTime(element.received_on) || '--';
            temp.status = element.status;
            temp.reverse_charge = element.reverse_charge;
            temp.due_date = this.timeService.toShortDateTime(element.due_date)|| '--';
            temp.received_amount = element.settled.net_amount ? element.settled.net_amount.toFixed(0) : '--';
            temp.customer = element.shipper._id;
            temp.existingInvoiceNo = element.CBIN.custom;
            temp._id =  element._id;
            this.bills.push(temp);
          });

          if (!this.billsList) {
            this.billsList = new MatTableDataSource(this.bills);
            this.billsList.sort = this.sort;
            this.billsList.paginator = this.paginator;
            this.paginator._intl.itemsPerPageLabel= this.translation.instant('BILLS.pagination_label');
          } else {
            this.billsList = new MatTableDataSource(this.bills);
            this.paginator._intl.itemsPerPageLabel= this.translation.instant('BILLS.pagination_label');
          }
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.bills = [];
        this.billsList = new MatTableDataSource(this.bills);
        this.billsList.sort = this.sort;
        this.billsList.paginator = this.paginator;
        this.status_data.pending_for_payment.loader = false;
        this.status_data.completely_received.loader = false;
        this.status_data.partially_received.loader = false;
        this.status_data.pending_for_payment.value = '--' ;
        this.status_data.completely_received.value = "--" ;
        this.status_data.partially_received.value = "--";
        console.log('Err-=', err);
        this.paginator._intl.itemsPerPageLabel= this.translation.instant('BILLS.pagination_label');
      }
    );
  }

  pageNavigate(event: PageEvent) {
    this.billFilters.limit = event.pageSize;
    this.billFilters.skip = event.pageIndex * event.pageSize;    
    this.getBills(this.billFilters);
  }

  applyFilter(value){

  }

  quickBooks() {
    window.open(this.url);
    //
  }

  moveToQbo(element) {
    this.qboData.user_id = this.userId;
    this.qboData.lines.push({amount: element.amount});
    this.qboData.customer = element.customer;
    this.commentDialogRef = this.dialog.open(this.commentDialog);
  }
  postQbo() {
    if (environment.country === 'IN') {
      this.http.customPost(environment.API_URL_QUICKBOOKS + 'invoice', this.qboData ).subscribe(
        (data: any) => {
          if (data.statusCode === 200) {
            this.snackBar.openSnackBar('Successful', '');
            this.commentDialogRef.close();
          }
        },
        (err: any) => {
          console.log('err =-=', err);
          this.snackBar.openSnackBar(err.error.message, '', 'err');
        }
      );
    }
  }

  openCreateCreditNoteModal(element){
    element.transit_type = this.selectedTransitType.value
    const dialogRef = this.dialog.open(CreditNoteComponent,{
      data:element
    });
  }

  selectTransitType(transit_type){
    this.selectedTransitType = transit_type;
    this.billFilters.transit_type = this.selectedTransitType.value;
    this.getBills(this.billFilters);
  }

  openConsolidateInvoiceDialg(element) {
    this.invoiceId = element._id;
    this.existingInvoice = element.existingInvoiceNo || element.bill_id;
    this.editConsolidateInvoiceRef = this.dialog.open(this.editConsolidateInvoiceDialog, {
      panelClass: 'icon-outside',
    });
  }

  updateConsolidateInvoice() { 
    const payload = {
      invoiceId: this.invoiceId,
      customInvoiceNumber: this.newInvoice,
    }
    this.http.post('v1/update/consolidate_invoice_number', payload,1).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.getBills();
          this.snackBar.openSnackBar('Successful', '');
          this.editConsolidateInvoiceRef.close();
          this.invoiceId = '';
          this.newInvoice = ''
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      });
  }
}
